const pagination = {
  iconSize: { default: 16 },

  pageSize: { default: 40 },

  pageBorderRadius: { default: 20 },
}

export default pagination
